import React, { createContext, useMemo, useCallback } from 'react';
import { useLazyQuery } from '@apollo/react-hooks';
import { NULL_USER } from '../../lib/user';
import { useUser } from '../../hooks/useUser';
import { GET_FAVORITES_QUERY, GetFavoritesResponse } from './favorites.rest';

// creating a React context for favorites to fix performance problems caused by using a useQuery in every VariantCell
export const FavoritesContext = createContext({
  user: NULL_USER,
  favorites: [] as number[],
  getFavorites: () => {
    return;
  }
});

export const FavoritesProvider: React.FC = ({ children }) => {
  const { user } = useUser();
  const [fetchFavorites, { data, called }] = useLazyQuery<GetFavoritesResponse>(
    GET_FAVORITES_QUERY
  );

  const favorites = useMemo(() => data?.userFavorites.data.attributes.variantIds || [], [data]);
  const getFavorites = useCallback(() => {
    if (user.isLoggedIn && !called) fetchFavorites();
  }, [user.isLoggedIn, fetchFavorites, called]);

  return (
    <FavoritesContext.Provider value={{ user, favorites, getFavorites }}>
      {children}
    </FavoritesContext.Provider>
  );
};
